import { User, UserSuperRole } from '@/typings/user';
import { UserRoles } from '@/utils/roles';

export function isDebugAllowed(user: User | null, debugInfoActivated: boolean) {
  const isSuper =
    user?.superRole &&
    (user.superRole === UserSuperRole.SUPER_ADMIN || user.superRole === UserSuperRole.SUPPORT);

  return debugInfoActivated && !!isSuper;
}

export function isAdvancedSettingsOpted(user: User | null, advancedSettingsActivated: boolean) {
  const isAllowed =
    user?.organizations &&
    (user?.organizations[0]?.role === UserRoles.admin ||
      user?.organizations[0]?.role === UserRoles.super);

  return !!isAllowed && !!advancedSettingsActivated;
}
